import initDatatableLoadMore from './datatable/loadMore';


const initPlugin = () => {
    initDatatableLoadMore();
};


export default initPlugin;
